module.exports = __webpack_public_path__ + "static/david-heinemeier-hansson-cede72d7d3acd7253d5d97052197af34.jpg";